import * as React from "react";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import { Skeleton } from "@mui/material";
import { useContextData } from "../hooks/useContextData";

const emails = ["username@gmail.com", "user02@gmail.com"];

export interface SimpleDialogProps {
  open: boolean;
  selectedValue: string;
  onClose: (value: string) => void;
  imageSource: string;
}

function SimpleDialog(props: SimpleDialogProps) {
  const { onClose, selectedValue, open } = props;
  const [imageLoaded, setImageLoaded] = React.useState(false);
  const { theme } = useContextData();

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleListItemClick = (value: string) => {
    onClose(value);
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <List
        style={{
          backgroundColor: theme === "dark" ? "#5c5f63" : "white",
          color: theme === "dark" ? "#FAFAFA" : undefined,
        }}
        sx={{ pt: 0, px: 3, pb: 2 }}
      >
        {!imageLoaded && (
          <Skeleton
            variant="rectangular"
            width={400}
            height={400}
            sx={{
              borderRadius: "8px",
              marginTop: "16px",
            }}
          />
        )}
        <img
          src={props.imageSource}
          alt="Expanded"
          style={{
            width: 400,
            height: 400,
            borderRadius: "8px",
            marginTop: "16px",
            display: imageLoaded ? "block" : "none",
          }}
          onLoad={() => setImageLoaded(true)}
        />
      </List>
    </Dialog>
  );
}

type Props = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  image: string;
};

export default function ExpandedImage({ open, setOpen, image }: Props) {
  const [selectedValue, setSelectedValue] = React.useState(emails[1]);

  const handleClose = (value: string) => {
    setOpen(false);
    setSelectedValue(value);
  };

  return (
    <div>
      <SimpleDialog
        selectedValue={selectedValue}
        open={open}
        onClose={handleClose}
        imageSource={image}
      />
    </div>
  );
}
